<template>
  <div>
    <!-- <div v-if="canEditCms" class="d-flex justify-content-end">
      <a :href="fetchLegacyUrl(`/workshops/${$route.params.id}/schedules/new`)">
        <button class="btn btn-primary btn-md">Add New schedule item</button>
      </a>
    </div> -->
    <div v-if="canEditCms" class="mb-3">
      <div class="row mb-2 mt-2">
        <div class="col-md-3">
          <span class="text-muted regular-16">Academic Year</span>
        </div>
        <div class="col-md-3">
          <div class="regular-16">{{data.academic_year}}</div>
        </div>
        <div class="col-md-3">
          <span class="text-muted regular-16">Status</span>
        </div>
        <div class="col-md-3">
          <div class="regular-16">{{data.status}}</div>
        </div>
      </div>
      <div class="row mb-2 mt-2">
        <div class="col-md-3">
          <span class="text-muted regular-16">Duration</span>
        </div>
        <div class="col-md-3">
          <div class="regular-16">{{data.duration}}</div>
        </div>
        <div class="col-md-3">
          <span class="text-muted regular-16">Location</span>
        </div>
        <div class="col-md-3">
          <div class="regular-16">{{data.location}}</div>
        </div>
      </div>
      <div class="row mb-2 mt-2">
        <div class="col-md-3">
          <span class="text-muted regular-16">Categories</span>
        </div>
        <div class="col-md-9">
          <span class="regular-16" v-for="(category, index) in data.categories" :key="index">
            <span v-if="index < data.categories.length - 1">{{category.name}}, </span>
            <span v-else>{{category.name}}</span>
          </span>
        </div>
      </div>
      <div class="row mb-2 mt-3">
        <div class="col-md-12">
          <div class="lyon-display-medium-24 mb-2">Program Notes</div>
          <div v-if="data.event_notes">
            <span class="regular-16 custom-html-text" v-html = "data.event_notes"/>
          </div>
          <div v-else>
            <span class="text-muted regular-14">No Notes</span>
          </div>
        </div>
      </div>
      <div class="row mb-2 mt-2">
        <div class="col-md-12">
          <div class="lyon-display-medium-24 mb-2">Proposal Notes</div>
          <div v-if="data.proposal_notes">
            <div class="typo-color-blue">
              <span>
                <a v-b-toggle="'proposal-notes-collapse'" @click.prevent>
                  <i v-b-tooltip.hover ="'Show more'" class="fas fa-eye cursor-pointer" />
                  <span class="typo-color-blue regular-14 cursor-pointer">Show more</span>
                </a>
              </span>
            </div>
            <b-collapse v-bind:id="'proposal-notes-collapse'">
              <b-card>
                <div class="custom-html-text regular-16" v-html="data.proposal_notes"/>
              </b-card>
            </b-collapse>
          </div>
          <div v-else>
            <span class="text-muted regular-14">No Notes</span>
          </div>
        </div>
      </div>
      <div class="lyon-display-medium-24 mb-2 mt-2">Representatives</div>
       <div v-if="data.representatives.length === 0">
        <span class="text-muted regular-14">No result</span>
      </div>
      <div v-else v-for="(representative, index) in data.representatives" :key="index" class="mb-1">
        <span class="px-2 badge badge-pill badge-secondary">
          <span class="regular-14 typo-color-white">
            {{ representative.type }}
          </span>
        </span>
        <span class="mr-1">
          <a :href="`mailto:${representative.person_email}`"><i class="fas fa-envelope" /></a>
        </span>
        <router-link :to="{ name: 'people', params: { id: representative.person_id }, query: { reDirectFrom: 'link' }}">
          <span class="typo-color-blue regular-16">{{ representative.name }}</span><span class="typo-color-black">,</span>
        </router-link>
        <span class="regular-14">
          {{representative.institution}}
        </span>
      </div>
    </div>
    <!-- <div class="lyon-display-medium-24">Notes</div>
    <div v-if="data.program_schedules.length === 0">
      <span class="text-muted regular-14">No result</span>
    </div>
    <div v-else v-for="(program, index) in data.program_schedules" :key="index">
      <b-card :class="index%2 === 1 ? 'bg-shade-2 mb-2' : 'bg-shade-1 mb-2'">
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="regular-16 text-muted mb-2">
            <span>{{moment(program.from, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY')}}</span>
            <span> - </span>
            <span>{{moment(program.to, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY')}}</span>
          </div>
          <div class="bold-21">{{program.name}}</div>
          </div>
        </div>
        <div v-for="(item, j) in program.schedules" :key="j">
          <b-card no-body>
            <div class="row mt-3 p-2 custom-mbl-text-align">
              <div class="col-md-2 mb-2">
                <div class="text-center">
                  <div class="text-muted regular-14">
                    <span>{{moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('MMM')}}</span>
                  </div>
                  <div class="bold-32">
                    <span>
                      <span>{{moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('DD')}}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-8 mb-2">
                  <div class="text-muted regular-14">
                    <i class="fas fa-clock mr-2" />
                    <span>{{moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('hh:mm a')}}</span>
                    <span> - </span>
                    <span>{{moment(item.to, 'YYYY-MM-DD HH:mm:ss').format('hh:mm a')}}</span>
                  </div>
                  <div class="bold-16 mt-2">
                    <span>
                      {{ item.title }}
                    </span>
                  </div>
              </div>
              <div class="col-md-2">
                <div class="typo-color-blue">
                  <span>
                    <a v-b-toggle="'collapse' + index+j" @click.prevent><i v-b-tooltip.hover ="'View More Details'" class="fas fa-eye cursor-pointer"></i></a>
                  </span>
                </div>
              </div>
            </div>
            <b-collapse v-bind:id="'collapse' + index+j">
              <div class="ml-5 mr-5 p-2">
                <div class="row mb-2 mt-2">
                  <div class="col-md-4">
                    <span class="text-muted regular-16">Location</span>
                  </div>
                  <div class="col-md-8">
                    <div class="regular-16">{{item.schedules_event_location}}</div>
                  </div>
                </div>
                <div class="row mb-2 mt-2">
                  <div class="col-md-4">
                    <span class="text-muted regular-16">Video</span>
                  </div>
                  <div class="col-md-8">
                    <div class="regular-16 typo-color-blue" v-if="item.videos.length > 0">
                      <router-link
                        :to="{ name: 'program-schedules',
                        params: { id: data.id, schedule_id: item.id}}"
                      >
                      <span v-b-tooltip.hover.top="item.videos.length + ' Video/Audio File Available'">
                        <i class="fas fa-film"></i>
                        Watch Video
                      </span>
                      </router-link>
                    </div>
                    <div v-else>
                      <span class="regular-16">--</span>
                    </div>
                  </div>
                </div>
                <div class="row mb-2 mt-2">
                  <div class="col-md-4">
                    <span class="text-muted regular-16">Abstract</span>
                  </div>
                  <div class="col-md-8">
                    <div class="regular-16 custom-html-text" v-html = "item.abstract" />
                  </div>
                </div>
                <div class="row mb-2 mt-2">
                  <div class="col-md-4">
                    <span class="text-muted regular-16">Supplement</span>
                  </div>
                  <div class="col-md-8">
                    <div class="regular-16" v-if="item.documents.length > 0">
                      <div v-for="(supplement, index) in item.documents" :key="index">
                        <div v-for="(item, i) in supplement.document_files" :key="i">
                          <span class="regular-16 cursor-pointer">
                            <a :href="item.download_asset_path" target="_blank">
                              <i class="fas fa-file"></i>
                              {{item.data_file_name}}
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <span class="regular-16">--</span>
                    </div>
                  </div>
                </div>
                <div class="row mb-2 mt-2">
                  <div class="col-md-9">
                  </div>
                  <div class="col-md-3">
                    <router-link
                      :to="{ name: 'program-schedules',
                      params: { id: data.id, schedule_id: item.id}}"
                    >
                      <span v-b-tooltip.hover.top="'Show Detail'">
                        <i class="fa fa-info-circle"></i>
                        Show Detail
                      </span>
                    </router-link>
                    <a
                      :href="fetchLegacyUrl(`/workshops/${item.workshop_id}/schedules/${item.id}/edit`)"
                      v-if="canEditCms"
                    >
                      <span v-b-tooltip.hover.top="'Edit'">
                        <i class="fas fa-edit ml-2"></i>
                        Edit
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              </b-collapse>
          </b-card>
        </div>
      </b-card>
    </div> -->
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ProgramScheduleAndNotesTabSection',
  props: ['data'],
  mixins: [mixin],
  computed: {
    ...mapGetters(['canEditCms'])
  }
}
</script>
